import { useState, useContext, use, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { GlobalContext } from '../../../store/GlobalState';
import { createToast } from '../../../utilities/toastHelpers';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiUrl } from '../../../utilities/requestHelpers';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import './ForgetPassword.css'

const ForgetPassword = () => {
  const { jwtToken, toggleToasts } = useContext(GlobalContext);
  const location = useLocation();
  const navigate=useNavigate()

  const [userName, setUserName] = useState('');
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Extract query parameters
    const queryParams = new URLSearchParams(location.search); 
    const email = queryParams.get('Email');
    const getToken = queryParams.get('Token');
    setUserName(email);
    setToken(getToken);
    if (getToken) {
      fetchToken(getToken);
    }

  }, []);

  const fetchToken = async (newToken) => {
    console.log("newToken", newToken);
    debugger
    try {
      const res = await axios.get(`${apiUrl}/authentication/validate-token?token=${newToken}`);
      console.log("Token validation success:", res.data);
      debugger
      if(res.status != 200){
        window.location.href = "/pagenotfound";
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Token not found.");
        window.location.href = "/pagenotfound";
      } else {
        console.error("Error validating token:", error.response?.data || error.message);
      }
    }
  };

  const handleFormSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    // Check if new password and confirm password match
    if (newPassword !== confirmPassword) {
      setLoading(false);
      toggleToasts(createToast('danger', 'Passwords do not match.'));
      return;
    }
    if(newPassword.length < 8){
      setLoading(false);
      toggleToasts(createToast('danger', 'Passwords must be greater than 8 character.'));
      return;
    }

    const user = {
      username: userName,
      password: newPassword,
      token: token,
    };

    try {
      // Making the API call to reset password
      console.log("apiurl", apiUrl);
      const response = await axios.post(
        `${apiUrl}/authentication/reset-password-via-ravenDb`, // Make sure this URL is correct for your API
        user, // Pass the user object to the body of the request
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      // If the response is successful
      if (response.status == '200') {
        setLoading(false);
        toggleToasts(createToast('success','Password reset successfully!'));
        navigate('/')
      } else {
        setLoading(false);
        toggleToasts(createToast('danger','Something went wrong.'));
      }
    } catch (error) {
      setLoading(false);
      toggleToasts(createToast('danger', 'An error occurred. Please try again later.'));
    }
  };
  const handleFormSubmitViaManager = async (e) => {
    setLoading(true);
    e.preventDefault();

    // Check if new password and confirm password match
    if (newPassword !== confirmPassword) {
      setLoading(false);
      toggleToasts(createToast('danger', 'Passwords do not match.'));
      return;
    }
    if(newPassword.length < 8){
      setLoading(false);
      toggleToasts(createToast('danger', 'Passwords must be greater than 8 character.'));
      return;
    }

    const user = {
      username: userName,
      password: newPassword,
      token: token,
    };

    try {
      // Making the API call to reset password
      const response = await axios.post(
        `${apiUrl}/authentication/reset-password-via-usermanager`, // Make sure this URL is correct for your API
        user, // Pass the user object to the body of the request
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      // If the response is successful
      if (response.status == '200') {
        setLoading(false);
        toggleToasts(createToast('success','Password reset successfully!'));
        navigate('/')
      } else {
        setLoading(false);
        toggleToasts(createToast('danger','Something went wrong.'));
      }
    } catch (error) {
      setLoading(false);
      toggleToasts(createToast('danger', 'An error occurred. Please try again later.'));
    }
  };

    return (
      <div className="form-page">
        <div className="form-container">
          <Form onSubmit={(e) => handleFormSubmit(e)}>
            <Form.Group className="mb-3">
              <Form.Control
                type="password"
                required
                placeholder="Enter New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="password"
                required
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>
            <button className="reset-button" type="submit" onClick={handleFormSubmit}>
              Save Password
            </button>
            {/* <button className="reset-password-button" type="submit" onClick={handleFormSubmitViaManager}>
              Reset Password Via UserManager
            </button> */}
          </Form>
          { loading && (
            <Spinner animation="border" className="forget-password-spinner" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
        </div>
      </div>
    );
};

export default ForgetPassword;
